export default {
  methods: {
    showErrorDialog(e) {
      // eslint-disable-next-line no-console
      console.log('errorDialog:', { error: e, response: e.response });

      const title = 'Error';
      let { message } = e;

      if (e.message === 'Network Error') {
        message = 'Failed to connect to backend service.';
      }
      else if (e.response?.data?.code) {
        switch (e.response.data.code) {
          case 'BLOCKED':
            message = 'This account has been blocked. Please contact system administrator.';
            break;
          case 'NOT_FOUND':
            message = 'Incorrect username or password.';
            break;
          default:
            message = e.response.data.message;
        }
      }
      else if (e.response?.data?.messages) {
        message = e.response.data.messages;
      }

      this.$q.dialog({
        title,
        message,
      });
    },
  },
};
